import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { selectCompany, selectCompanyEvent } from '../../redux/preferences/selectors';
import CompanySubHeader from '../layouts/partials/CompanySubHeader';

const Welcome = ({ event, company }) => {
  const { t } = useTranslation();

  if (event) {
    let registration = company.registrations.filter((registration) => registration.eventId === event.id);

    if (registration) {
      registration = registration[0];
    }

    return [
      <CompanySubHeader title="Dashboard" key="subheader" />,
      <div className="m-content" key="content">
        <div className="row">
          <div className="col-lg-7">
            <div className="m-portlet">
              <div className="m-portlet__head">
                <div className="m-portlet__head-caption">
                  <div className="m-portlet__head-title">
                    <span className="m-portlet__head-icon">
                      <i className="flaticon-rocket" />
                    </span>
                    <h3 className="m-portlet__head-text">
                      {event.name} <small>{t('General Info')}</small>
                    </h3>
                  </div>
                </div>
              </div>
              {company.crewAdmin || company.crewAdmin || company.crewAdmin ? (
                <div
                  className="m-portlet__body prose"
                  dangerouslySetInnerHTML={{
                    __html: event.crewAdminWelcomeHtml,
                  }}
                />
              ) : (
                <div className="m-portlet__body prose">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: event.crewMemberWelcomeHtml,
                    }}
                  />

                  <p>
                    <Link to="/profile" className="btn btn-primary">
                      Check your data
                    </Link>
                  </p>
                </div>
              )}
            </div>
          </div>
          <div className="col-lg-5">
            <div className="m-portlet">
              <div className="m-portlet__head">
                <div className="m-portlet__head-caption">
                  <div className="m-portlet__head-title">
                    <span className="m-portlet__head-icon">
                      <i className="flaticon-rocket" />
                    </span>
                    <h3 className="m-portlet__head-text">{t('Downloads')}</h3>
                  </div>
                </div>
              </div>
              <div className="m-portlet__body">
                {!!company.crewAdmin && (
                  <a
                    href={registration.downloadVouchersUrl}
                    className="btn btn--download m-btn m-btn--icon btn-outline-warning m--margin-right-20 m--margin-bottom-20 m-btn--custom"
                    download="registration-vouchers.zip"
                  >
                    <span>
                      <i className="la la-download" />
                      <span>Download All Vouchers</span>
                    </span>
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>,
    ];
  }

  return 'loading...';
};

Welcome.propTypes = {
  event: PropTypes.object,
  company: PropTypes.object,
};

const mapStateToProps = function (state) {
  return {
    event: selectCompanyEvent(state),
    company: selectCompany(state),
  };
};

export default connect(mapStateToProps)(Welcome);
